import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Input, CircularProgress, Typography } from "@mui/material";
import PublishIcon from "@mui/icons-material/Publish";
import { styled } from "@mui/system";

const UploadButton = styled(Button)(({ theme }) => ({}));

function FileUpload({ setIsLoading }) {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);

  useEffect(() => {
    if (file) {
      handleUpload();
    }
  }, [file]);

  const handleFileChange = (e) => {
    console.log("File selected:", e.target.files[0]);
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      console.warn("No file selected.");
      alert("Please select a file first");
      return;
    }

    console.log("Starting file upload...");
    setIsLoading(true);
    setUploading(true);

    try {
      console.log("Getting presigned URL...");
      const response = await axios.get(
        "https://xycg5efjw5.execute-api.us-west-1.amazonaws.com/test/upload"
      );
      console.log("Presigned URL response:", response);

      const presignedUrl = JSON.parse(response.data.body).presignedUrl;

      console.log("Presigned URL:", presignedUrl);
      console.log("Presigned URL:", response.data.body);

      console.log("Uploading file to S3...");
      console.log(file.type);
      await axios.put(presignedUrl, file, {
        headers: {
          "Content-Type": file.type,
        },
      });
      console.log("File uploaded successfully.");

      setUploadSuccess(true);
      alert("File uploaded successfully");
    } catch (error) {
      console.error("An error occurred:", error);
      alert("Failed to upload file");
    } finally {
      setUploading(false);
      setIsLoading(false);
      console.log("Upload process completed.");
    }
  };

  return (
    <div style={{ marginTop: "50px" }}>
      {uploading && !uploadSuccess ? <CircularProgress /> : null}
      {uploadSuccess ? (
        <Typography variant="h6">Upload Successful!</Typography>
      ) : null}
      {!uploading && !uploadSuccess ? (
        <>
          <Input
            type="file"
            onChange={handleFileChange}
            id="contained-button-file"
            style={{ display: "none" }}
          />
          <label htmlFor="contained-button-file">
            <UploadButton
              variant="contained"
              component="span"
              startIcon={<PublishIcon />}
            >
              Select and Upload to S3
            </UploadButton>
          </label>
        </>
      ) : null}
    </div>
  );
}

export default FileUpload;
